<template>
  <div class="site-page contact-page">
    <section class="sub-page-banner contact-banner">
      <div class="site-container">
        <h1>联系我们</h1>
      </div>
    </section>

    <div class="site-container contact-wrap">
      <section class="section-card contact-card">
        <!-- Tab -->
        <div class="tab-bar">
          <button
            v-for="tab in tabs"
            :key="tab.key"
            type="button"
            :class="{ active: currentTab === tab.key }"
            @click="currentTab = tab.key"
          >
            {{ tab.label }}
          </button>
        </div>

        <!-- 通用内容：用同一套模板渲染所有 office -->
        <div
          class="contact-main"
          v-for="office in offices"
          :key="office.key"
          v-show="currentTab === office.key"
        >
          <div class="head-row">
            <div class="title-block">
        <img src="@/assets/imgs/ysgj_033@2x.png" alt="地址" class="loc-icon" loading="lazy">
              <div>
                <h3>{{ office.enName || office.name }}</h3>
                <p>{{ office.address }}</p>
              </div>
            </div>
            <div class="contact-grid">
              <div class="contact-item" v-for="c in office.contacts" :key="c.icon + c.label">
                <img :src="iconMap[c.icon] || iconMap.phone" alt="" loading="lazy">
                <span class="label">{{ c.label }}：</span>
                <span class="value">{{ c.value }}</span>
              </div>
            </div>
          </div>

          <!-- 交通指引（有就显示，没有不显示） -->
          <div class="route-note" v-if="office.routes && office.routes.length">
            <p v-for="item in office.routes" :key="item">• {{ item }}</p>
          </div>

          <div class="map-box">
          <img :src="office.mapImage" alt="地图" loading="lazy">
          </div>
        </div>
      </section>
    </div>

    <div class="float-tools">
      <button class="tool-btn" type="button" @click="scrollTop">
        <img src="@/assets/imgs/ysgj_006@2x.png" alt="顶部" loading="lazy">
      </button>
      <button class="tool-btn" type="button" @click="showMessage">
        <img src="@/assets/imgs/ysgj_007@2x.png" alt="咨询" loading="lazy">
      </button>
    </div>
  </div>
</template>

<script>
import { getContactData } from '@/api'

export default {
  name: 'Contact',
  data() {
    return {
      currentTab: 'shanghai',
      tabs: [
        { key: 'shanghai', label: '上海总部' },
        { key: 'auckland', label: '新西兰' }
      ],
      offices: [],
      iconMap: {
        mobile: require('@/assets/imgs/ysgj_035@2x.png'),
        phone: require('@/assets/imgs/ysgj_036@2x.png'),
        email: require('@/assets/imgs/ysgj_034@2x.png'),
        zipcode: require('@/assets/imgs/ysgj_037@2x.png'),
        postal: require('@/assets/imgs/ysgj_037@2x.png'),
      },
    }
  },
  created() {
    this.fetchContactData()
  },
  methods: {
    async fetchContactData() {
      try {
        const res = await getContactData()
        // 兼容两种后端返回：{ offices: [...] } 或 { shanghai: {...}, auckland: {...} }
        if (res && Array.isArray(res.offices)) {
          this.offices = res.offices
        } else if (res && (res.shanghai || res.auckland)) {
          this.offices = []
          if (res.shanghai) this.offices.push(this.normalizeOffice('shanghai', res.shanghai))
          if (res.auckland) this.offices.push(this.normalizeOffice('auckland', res.auckland))
        } else {
          this.offices = []
        }
      } catch (error) {
        this.offices = []
      }
    },
    normalizeOffice(key, data) {
      const office = { key, ...data }
      // 旧接口返回的是平铺字段，转换成 contacts 数组给新模板用
      if (!office.contacts || !office.contacts.length) {
        const contacts = []
        if (key === 'shanghai') {
          if (data.mobile) contacts.push({ icon: 'mobile', label: '手机', value: data.mobile })
          if (data.phone) contacts.push({ icon: 'phone', label: '电话', value: data.phone })
          if (data.email) contacts.push({ icon: 'email', label: '电邮', value: data.email })
          if (data.zipcode) contacts.push({ icon: 'zipcode', label: '邮编', value: data.zipcode })
        } else {
          if (data.phone) contacts.push({ icon: 'phone', label: 'Ph', value: data.phone })
          if (data.mobile) {
            const mbVal = data.mobile + (data.contactPerson ? ' ' + data.contactPerson : '')
            contacts.push({ icon: 'mobile', label: 'Mb', value: mbVal })
          }
          if (data.email) contacts.push({ icon: 'email', label: 'Email', value: data.email })
          if (data.postalAddress) contacts.push({ icon: 'postal', label: 'Postal Address', value: data.postalAddress })
        }
        office.contacts = contacts
      }
      // 旧接口的 route / routes 兼容
      if (!office.routes) {
        if (Array.isArray(data.route)) office.routes = data.route
        else if (typeof data.route === 'string' && data.route) office.routes = [data.route]
        else office.routes = []
      }
      return office
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    showMessage() {
      this.$Message.info('在线咨询功能开发中...')
    },
  },
}
</script>

<style scoped>
.contact-banner {
  background-image: url('~@/assets/imgs/ysgj_040@2x.png');
  background-position: center;
  background-size: cover;
}

.contact-wrap {
  position: relative;
  z-index: 4;
  margin-top: -18px;
}

.contact-card {
  padding: 0;
  overflow: hidden;
}

.tab-bar {
  height: 46px;
  border-bottom: 1px solid #e7edf5;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 0 16px;
}

.tab-bar button {
  position: relative;
  border: none;
  background: none;
  color: #7a8595;
  font-size: 14px;
  height: 100%;
  cursor: pointer;
}

.tab-bar button.active {
  color: #2d5f9f;
  font-weight: 700;
}

.tab-bar button.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: var(--site-blue);
}

.contact-main {
  padding: 18px;
}

.head-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
}

.title-block {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.title-block .loc-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  margin-top: 4px;
}

.title-block h3 {
  font-size: 18px;
  color: #46536b;
  line-height: 1.35;
  margin-bottom: 6px;
}

.title-block p {
  font-size: 13px;
  color: #5f6a79;
  line-height: 1.7;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
  align-content: center;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #5f6a79;
  line-height: 1.6;
}

.contact-item img {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  object-fit: contain;
}

.contact-item .label {
  color: #8a92a0;
  flex-shrink: 0;
}

.contact-item .value {
  color: #2d2f33;
  font-weight: 500;
}

.map-box {
  margin-top: 16px;
  height: 360px;
  border-radius: 10px;
  overflow: hidden;
  background: #e8f0f8;
  border: 1px solid #dce6f4;
}

.map-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.route-note {
  margin-top: 12px;
}

.route-note p {
  font-size: 13px;
  color: #6a7484;
  line-height: 1.8;
}

.float-tools .tool-btn {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.float-tools .tool-btn img {
  width: 46px;
  height: 46px;
}

</style>
